// Row action keys of the backend checkout-profile, checkout-rule and checkout-profile-rule grids.
export const CHECKOUT_GRID_ACTION_KEYS = {
  setAsActive: 'setAsActive',
  setAsInactive: 'setAsInactive',
  delete: 'delete',
  moveUp: 'moveUp',
  moveDown: 'moveDown',
} as const;
